<template>
  <b-modal id="add-ship-modal" :title="$t('fleet.addECDIS')" centered hide-footer>
    <div class="d-flex flex-column">
      <b-button variant="primary" class="mb-3" @click="addShipByQR">
        <i class="fas fa-qrcode mr-2"></i> {{ $t('fleet.addByQR') }}
      </b-button>
      <b-button variant="primary" @click="addShipManually">
        <i class="fas fa-edit mr-2"></i> {{ $t('fleet.addManually') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {eventBus} from "@/main";

export default {
  methods: {
    // Метод для добавления судна по QR-коду
    addShipByQR() {
      // Закрыть модальное окно
      this.$bvModal.hide('add-ship-modal');

      // Открыть окно для сканирования QR-кода
      setTimeout(() => {
        this.$root.$emit('bv::toggle::collapse', 'scan-qr')
        eventBus.$emit('start-scan-qr-info');
      }, 300);
    },
    // Метод для добавления судна вручную
    addShipManually() {
      this.$bvModal.hide('add-ship-modal');

      this.$root.$emit('bv::toggle::collapse', 'ship-edit')
      this.$nextTick(() => {
        eventBus.$emit('clean-ecdis')
      })
    }
  }
}
</script>